<div class="panel panel-flat">
  <div class="content-group">
    <div class="panel-body">

      <div class="row">

        <div id="overlay">
          <h3 id="text">{{startingInHeader}}</h3>
          <h3 *ngIf="showCountDown" id="countdown">{{ showTime }}</h3>
        </div>

        <!--   <div *ngIf="showWheel" id="wheel_cont" class="col-md-12 text-center"> -->
        <div id="wheel_cont" class="col-md-12 text-center">
          <ngx-wheel #wheel width='400' height='400' spinDuration='8' [disableSpinOnClick]='true' [items]='items'
            [innerRadius]='20' [spinAmount]='20' pointerStrokeColor='white' pointerFillColor='brown'
            [idToLandOn]='idToLandOn' (onSpinStart)='before()' (onSpinComplete)='after()'>
          </ngx-wheel>
        </div>
        <div *ngIf="showWinner" class="col-md-10">
          <div class="panel panel-body">
            <div class="media">
              <div class="media-left">
                <a data-popup="lightbox">
                  <img src="assets/images/user.jpg" style="width: 70px; height: 70px;" class="img-circle img-md" alt="">
                </a>
              </div>

              <div class="media-body">
                <h6 class="media-heading">{{this.winner.text}}</h6>
                <p class="text-muted">Code: {{this.winner.id}}</p>
                <ul class="" style="list-style-type:none">
                  <li>1,200,000.00 ETB</li>
                  <li>Oct 30, 2021</li>
                  <li></li>
                </ul>
              </div>
              <div class="media-right media-middle">
                <i class="icon-trophy"></i>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>